import React from 'react';
import Main from './Main';
import './styles.css';

function App() {
  return (
    <>
      <Main/>
    </>
  );
}

export default App;